// A child season's short name means little on its own ("F4" rather than
// "Formula Invitational 2026 - F4"), so qualify it with the parent's when the API sends one.
// The API always returns the season's own `shortName`; `parentSeasonShortName` is null for
// parent and standalone seasons.
export const getSeasonShortName = (season) =>
  season?.parentSeasonShortName
    ? `${season.parentSeasonShortName} - ${season.shortName}`
    : season?.shortName;

// The season a row belongs to at its broadest: the parent when there is one, the season itself
// otherwise. Used where the child's own short name would only add noise ("Formula Invitational 26"
// rather than "Formula Invitational 26 - Formula 4").
export const getRootSeasonShortName = (season) =>
  season?.parentSeasonShortName || season?.shortName;
